import { render } from "./BotaoEditar.vue?vue&type=template&id=4f1b096e&ts=true"
import script from "./BotaoEditar.vue?vue&type=script&lang=ts"
export * from "./BotaoEditar.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__